/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prompt_Tips_Decompose_TitleInputs */

const es_prompt_tips_decompose_title = /** @type {(inputs: Prompt_Tips_Decompose_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descomponé consultas grandes`)
};

const en_prompt_tips_decompose_title = /** @type {(inputs: Prompt_Tips_Decompose_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Break down large queries`)
};

/**
* | output |
* | --- |
* | "Break down large queries" |
*
* @param {Prompt_Tips_Decompose_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const prompt_tips_decompose_title = /** @type {((inputs?: Prompt_Tips_Decompose_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prompt_Tips_Decompose_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_prompt_tips_decompose_title(inputs)
	return en_prompt_tips_decompose_title(inputs)
});
export { prompt_tips_decompose_title as "prompt_tips.decompose_title" }